import {
	PAGINATION_INLINE_PAGE_LIMIT,
	PAGINATION_PAGE_WINDOW,
} from "@klarify/constants";

export const buildPageList = (
	page: number,
	total: number,
): (number | "…")[] => {
	if (total <= PAGINATION_INLINE_PAGE_LIMIT) {
		return Array.from({ length: total }, (_, i) => i + 1);
	}
	const out: (number | "…")[] = [];
	const left = Math.max(2, page - PAGINATION_PAGE_WINDOW);
	const right = Math.min(total - 1, page + PAGINATION_PAGE_WINDOW);
	out.push(1);
	if (left > 2) {
		out.push("…");
	}
	for (let p = left; p <= right; p++) {
		out.push(p);
	}
	if (right < total - 1) {
		out.push("…");
	}
	out.push(total);
	return out;
};
